import React, { Component} from 'react'
import { Grid, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import VoltaxPlayer from './VoltaxPlayer'
import PlayerPlaylist from './PlayerPlaylist'
import useStyles from './styles/PlayerStyle'
import { trackEvent, EventAction, EventCategory } from '../../services/Analytics'
class MainPlayer extends Component {
  constructor(props) {
    super(props)
    this.voltaxPlayer = React.createRef();

    this.state = {
      isPlaying: false,
      mediaId: null,
      currentPlayingVideoDetails: null,
      isLoadingNewVideo: false
    }
  }

  componentDidMount() {
    document.addEventListener("scroll", this.isInViewport);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.isInViewport);
  }

  isInViewport = () => {
    const bottom = this.viewElement.getBoundingClientRect().bottom;

    // view is not in view port - pause the player
    if (bottom < 0) {
      if (this.state.isPlaying) {
        this.pause()
      }
    }
  }

  pause = () => {
    this.setState({isPlaying: false})
    this.voltaxPlayer.current.pause()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.mediaId !== this.state.mediaId) {
      let playingVideoIndex = this.props.playlist.findIndex(item => item.payload_id === this.state.mediaId)
      this.setState({currentPlayingVideoDetails: this.props.playlist[playingVideoIndex]})
    }
  }

  render() {
    let setRef = (el) => {
        this.viewElement = el;
    };
    const classes = this.props.classes;
    const setIsPlaying = (source, isPlaying, mediaId) => {
      if (this.state.isLoadingNewVideo) {
        return
      }
      if (mediaId) {
        this.setState({isPlaying, mediaId})
      } else {
        this.setState({isPlaying})
      }
      if (source === "PlayerPlaylist") {
        if (mediaId !== this.state.mediaId) {
          trackEvent(EventCategory.MainPlayer, EventAction.PlayedVideoInMainPlayer, mediaId)
          this.voltaxPlayer.current.play(mediaId)
          this.setState({isPlaying: true, mediaId})
        } else if (this.state.isPlaying) {
          this.voltaxPlayer.current.pause()
        } else {
          this.voltaxPlayer.current.play()
        }
      }
    }
    return (
      <Grid ref={setRef} container direction="row" className={`${classes.mainPlayerContainer} player-container`}>
        <Grid item lg={8} md={7} sm={12}>
          <VoltaxPlayer
            ref={this.voltaxPlayer}
            playerId={this.props.playerId}
            playlistId={this.props.playlistId}
            mediaId={this.state.mediaId}
            setIsPlaying={(isPlaying, mediaId) => setIsPlaying("VoltaxPlayer", isPlaying, mediaId)}
            isLoadingNewVideo={this.state.isLoadingNewVideo}
            setIsLoadingNewVideo={isLoading => this.setState({isLoadingNewVideo: isLoading})}
          />
          <Grid item className={'player-texts-container'}>
            <Box
              className={`${classes.mainPlayerVideoTitle} player-title`}
              component="div"
              overflow="hidden"
              classes={{root: classes.mainPlayerTitleBoxRoot}}>
              {this.state.currentPlayingVideoDetails ? this.state.currentPlayingVideoDetails.title : ""}
            </Box>
            <Box
              className={`${classes.mainPlayerVideoDescription} player-subtitle`}
              component="div"
              overflow="hidden"
              classes={{root: classes.mainPlayerDescriptionBoxRoot}}>
              {this.state.currentPlayingVideoDetails ? this.state.currentPlayingVideoDetails.description : ""}
            </Box>
          </Grid>
        </Grid>
        <Grid item lg={4} md={5} sm={12}>
          <PlayerPlaylist
            playlist={this.props.playlist}
            mediaId={this.state.mediaId}
            isPlaying={this.state.isPlaying}
            setIsPlaying={(isPlaying, mediaId) => setIsPlaying("PlayerPlaylist", isPlaying, mediaId)}
            isLoadingNewVideo={this.state.isLoadingNewVideo}
          />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(MainPlayer)
